import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

function getFormInputs() {
    const {queryParams} = this.props;

    if (queryParams === undefined) {
        return null;
    }

    return Object.keys(queryParams).map((name, index) => {
        return (
            <input
                key={index}
                name={name}
                type="hidden"
                value={queryParams[name]}
            />
        );
    });
}

export default class FileDownload extends Component {

    static propTypes = {
        actionPath: PropTypes.string.isRequired,
        method: PropTypes.string,
        onDownloadComplete: PropTypes.func.isRequired,
        queryParams: PropTypes.object
    };

    static defaultProps = {
        method: 'POST'
    };
    submitForm  = function (e) {
        console.log('in submitform',e);
        e.stopPropagation()
         e.preventDefault();
    }
    componentDidMount() {
        console.log('in filedownload', this.props );

        ReactDOM.findDOMNode(this).submit();
       this.props.onDownloadComplete();
    }

    render() {
        console.log('in filedownload render' );
        const {actionPath, method} = this.props;

        return (
            <form
                onSubmit={this.submitForm}
                action={actionPath}
                className="hidden"
                method={method}
            >
                {getFormInputs.call(this)}
            </form>
        );
    }
}
